import './RightPanel.scss';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import { PanelDetails } from './RightPanelDetails';
import { ReactNode } from 'react';

const PanelWithLoadPanel = withLoadPanel(PanelDetails);

export const RightPanel = ({ children }: { children?: ReactNode }) => {
  return (
    <PanelWithLoadPanel
      hasData={true}
      panelProps={{
        position: { of: '.panel' },
        container: '.panel',
      }}>
      {children}
    </PanelWithLoadPanel>
  );
};
